import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Preloader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6, ease: "easeInOut" } }}
          className="fixed inset-0 z-[9999] bg-brand-navy flex flex-col items-center justify-center text-white"
        >
          <div className="relative flex flex-col items-center max-w-md px-6 text-center">
            {/* Heartbeat pulse animation using SVG */}
            <div className="w-48 h-24 mb-6 relative">
              <svg
                viewBox="0 0 200 100"
                className="w-full h-full stroke-brand-blue fill-none stroke-[3] stroke-linecap-round stroke-linejoin-round"
              >
                <motion.path
                  initial={{ pathLength: 0 }}
                  animate={{ 
                    pathLength: [0, 1, 1],
                    pathOffset: [0, 0, 1] 
                  }}
                  transition={{ 
                    duration: 1.8, 
                    ease: "easeInOut", 
                    repeat: Infinity 
                  }}
                  d="M 10 50 L 50 50 L 60 30 L 70 70 L 80 50 L 100 50 L 110 10 L 120 90 L 130 50 L 190 50"
                />
                {/* Emerald Green glowing glow path */}
                <motion.path
                  initial={{ pathLength: 0, opacity: 0.5 }}
                  animate={{ 
                    pathLength: [0, 1, 1],
                    pathOffset: [0, 0, 1] 
                  }}
                  transition={{ 
                    duration: 1.8, 
                    ease: "easeInOut", 
                    repeat: Infinity,
                    delay: 0.1
                  }}
                  className="stroke-brand-green opacity-40 blur-[2px]"
                  d="M 10 50 L 50 50 L 60 30 L 70 70 L 80 50 L 100 50 L 110 10 L 120 90 L 130 50 L 190 50"
                />
              </svg>
            </div>

            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="text-2xl font-bold font-montserrat text-white tracking-widest uppercase mb-2"
            >
              Kiran Distributors
            </motion.h1>

            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ delay: 0.4, duration: 0.8, ease: "easeOut" }}
              className="w-24 h-0.5 bg-brand-green mb-4 origin-center"
            />

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.7 }}
              transition={{ delay: 0.6, duration: 0.5 }}
              className="text-xs text-brand-silver font-poppins tracking-wider"
            >
              COMPLETE HEALTHCARE INFRASTRUCTURE
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
